module.exports = {
	"5fe6cc0473e0d313": "فشل في تسجيل الدخول",
	"ff09e2c6d332d9a9": "مدير خدمة ما بعد البيع لموزع الصيانة",
	"e700c28686cf9239": "مدير الخدمة",
	"ac4b9e617b460217": "المصدر الرئيسي",
	"cf9e55be6bc85b96": "وصف موجز",
	"2b68d9152e3d3db1": "وزير الدفاع",
	"051d6d3c0467ce2c": "شركة المبيعات",
	"8d7d36bc6fb6d6ac": "إدارة الشؤون الإدارية",
	"2c3949540a8af2b2": "المنطقة الشرقية صافي الشعر",
	"5cabbc13e4bee21a": "مدير البرنامج",
	"42c4c030fab33ead": "قسم التسويق",
	"54f11cc55ea6122f": "موزع العلامة التجارية أ",
	"d115f29ef6edb41f": "تقسيم المبيعات",
	"3417a5fcc3a35dec": "تقسيم المبيعات",
	"7bd27a06c47deebb": "تقسيم المبيعات لموزع A",
	"465d732d68ebdfbb": "عملية ناجحة",
	"d3ad9f48039d6f36": "يرجى إدخال كلمة مرور تفي بالقواعد",
	"9b9a980dcdf8e51a": "طول كلمة المرور هو 10 ~ 16 أرقام، وأنه يحتوي على الأقل: أحرف كبيرة، أحرف صغيرة، أرقام أو أحرف خاصة (فقط`~!@#$%^&*()_-) ثلاثة منهم",
	"db2a83c04d0d85ee": "الاثنين",
	"c9e78713e31e5c0c": "الثلاثاء",
	"a0da04db4f9323b6": "الأربعاء",
	"11071e8d339b611c": "الخميس",
	"77c043016d325c68": "الجمعة",
	"3d86ac98afd3c98b": "السبت",
	"ac2c5e612fb71dbb": "الأحد",
	"2a314654cf9d4b65": "فقط الآن",
	"400201ee4590ba25": "قبل دقائق",
	"38dff0847f8b6b54": "منذ ساعات",
	"acc203985e88c8ff": "منذ 1 يوم",
	"9954ce6437e66f41": "الشهر",
	"08dae0e0a7266acb": "متى",
	"cdf97643b4d2b4ec": "النقاط",
	"9e8d6372f23ed0ae": "جميع الحقوق محفوظة",
	"922c2d41bd36ae30": "يرجى التحقق مما إذا كان عنوان ورل الذي أدخلته صحيحا، يرجى النقر على الزر أدناه للعودة إلى الصفحة الرئيسية أو إرسال تقرير خطأ",
	"8cd396b24d50bde9": "العودة إلى الصفحة الرئيسية",
	"34655267df949d36": "الصفحة التي قمت بزيارتها غير موجودة...",
	"0c09f9f949502219": "أدخل اسم العضو / رقم الهاتف المحمول / عنوان البريد الإلكتروني",
	"e93cb6cc8d5978ed": "يرجى إدخال كلمة المرور",
	"f787a49b96414843": "يرجى تحديد فئة تسجيل الدخول",
	"29feb2a0dd8c64aa": "الموزع",
	"136c1cfccaefce89": "مصنعي الجهاز الأصلية",
	"a16c753c0ce27b93": "المستهلك",
	"a787eaff540ed815": "Chery الدولية منصة التسويق الذكي",
	"8efc7ede2b82d0d2": "مرحبا بكم في تسجيل الدخول",
	"b6bd35b4275ff215": "تسجيل الدخول العادي",
	"c7609e554782bec4": "تسجيل الدخول",
	"5c839808c79ec750": "نسيت كلمة المرور؟ ",
	"4c04782973d13249": "يرجى إدخال كلمة المرور الصحيحة",
	"35a9eeeeed94b9c5": "المصادقة",
	"1f899a083534373c": "إعادة تعيين كلمة المرور الجديدة",
	"25e03120b83ee4ed": "تم",
	"3037d5200851358c": "يرجى إدخال كلمة مرور جديدة",
	"12486c6be40db3e7": "يرجى إدخال كلمة المرور الجديدة مرة أخرى",
	"204ffab8a6e01870": "تحديد",
	"cb5652273096ee32": "العودة إلى صفحة تسجيل الدخول",
	"47a48843580a4a66": "يرجى إدخال كلمة المرور بالتنسيق الصحيح",
	"9be71a11b46a4836": "كلمة المرور التي تم إدخالها مرتين غير متسقة",
	"6f43ea859d9f785b": "طول كلمة المرور هو 10~16 الأرقام والأرقام والحروف والأحرف (فقط'~!@#$%^&*()_-) يحتوي على ثلاثة أنواع على الأقل",
	"5f572f4cad00da16": "إعادة تعيين كلمة المرور بنجاح",
	"29799f539ee6b906": "يرجى إدخال رقم هاتفك",
	"f1ee1d97e869e447": "يرجى إدخال رمز التحقق",
	"03108ca21c7aae62": "{0}يمكن الحصول عليها مرة أخرى في ثوان",
	"ace46c7b30cb9a6e": "الحصول على رمز التحقق",
	"b0dd7bfe25cfcd7c": "يرجى إدخال رقم الهاتف المحمول الصحيح",
	"c54f71547450a65d": "تم إرسال رمز التحقق بنجاح إلى{0}",
	"582eb6b01e3ddd0e": "رقم الهاتف المحمول تسجيل الدخول",
	"b43c9693cd8c2a86": "حساب الدخول",
	"e4e4d24449be2f3b": "البريد الإلكتروني تسجيل الدخول",
	"a4132369592eddf8": "من فضلك أدخل رقم هاتفك",
	"7b04a69f42606895": "الرجاء إدخال رقم الحساب الخاص بك",
	"616d3762556837aa": "الرجاء إدخال البريد الإلكتروني الخاص بك",
	"f6f6a306a8b4e68c": "أدخل رقم هاتفك",
	"e78e5ae48541083f": "أدخل رقم حسابك",
	"e1171e54815f0502": "أدخل صندوق البريد الخاص بك",
	"2d394cf2150beea9": "تسجيل الدخول",
	"9cd180bf2c9735b7": "الرجاء التحقق من رقم الهاتف المحمول الخاص بك إذا كان رمز التحقق لم يتم إرسالها .",
	"d49a93bb265a311d": "رمز التحقق",
	"e3fed7761201cc22": "لا يمكن أن نرى بوضوح ؟  تغيير",
	"ad4345dbaabe1479": "قدم"
};



//////////////////
// WEBPACK FOOTER
// ./locale/saudi.js
// module id = 7kJD
// module chunks = 8